export default "__VITE_ASSET__cc974f24__"